import { Grid } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import IIntegration from "../../../../models/IIntegration";
import { IMenuItem } from "../../../../models/IMenuItem";
import { IApplicationState } from "../../../../store";
import { selectAuth } from "../../../../store/auth/selectors";
import { FormErrors } from "../../../forms/FormErrors";
import FormTextField from "../../../forms/FormTextField";
import createInputHandlers from "../../../forms/inputHandlers";
import DataDirectionSelect from "../../DataDirectionSelect";
import SystemSelect from "../../SystemSelect";
import { IntegrationDialogError } from "../IntegrationDialogError";

interface INewIntegrationFormProps extends RouteComponentProps {
  form: IIntegration;
  setForm: (val: IIntegration) => void;
  formErrors: FormErrors<IIntegration>;
  submitError: string;
  userRoles: string[];
}

const NewIntegrationForm = (props: INewIntegrationFormProps): JSX.Element => {
  const { form, setForm, formErrors, submitError, userRoles } = props;
  const { handleChange, handleCheck } = createInputHandlers<IIntegration>(form, setForm);

  const handleOptionChange = (key: keyof IIntegration) => (option: IMenuItem | null) => {
    if (option === null) {
      option = {
        ID: 0,
        Name: "",
      };
    }

    setForm({
      ...form,
      [key]: option,
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ border: "1px solid #ccc", borderRadius: 8 }}>
        <FormTextField<IIntegration>
          name="Name"
          label="Integration Name - what is the name of your product or process?"
          onChange={handleChange}
          form={form}
          formErrors={formErrors}
        />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 32, border: "1px solid #ccc", borderRadius: 8 }}>
        <FormTextField<IIntegration>
          name="Description"
          label="Description - what does this Integration use to consume and/or provide data?"
          onChange={handleChange}
          form={form}
          formErrors={formErrors}
        />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 32 }}>
        <SystemSelect id={form.System.ID} onValueChange={handleOptionChange("System")} required apis={[]} error={formErrors["System"]} />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 32 }}>
        <DataDirectionSelect id={form.System.ID} onValueChange={handleOptionChange("DataDirection")} required error={formErrors["DataDirection"]} />
      </Grid>
      {submitError && (
        <Grid item xs={12}>
          <IntegrationDialogError errorMessage={submitError} />
        </Grid>
      )}
    </Grid>
  );
};

export default connect((state: IApplicationState) => {
  return {
    ...selectAuth(state),
  };
})(withRouter(NewIntegrationForm));
